<template>
  <button type="button"
          class="bookmark-button"
          :class="{ bookmarked: bookmarked }"
          :disabled="disabled"
          @click="onToggleFavorite">
    <span class="button">
      Toggle Bookmark
      <i class="icon icon--favorite"></i>
      <i class="icon icon--favorite off"></i>
    </span>
    <span v-if="disabled"
          class="tooltip"
          :class="$i18n.locale"
          v-html="$t('bookmark.maxOneForEveryonePlan')">
    </span>
  </button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UiBookmarkButton',
  props: {
    bookmarked: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState([
      'isDemo'
    ])
  },
  methods: {
    onToggleFavorite () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
.bookmark-button {
  position: relative;
  .button {
    position: relative;
    width: 30px;
    height: 30px;
    text-indent: -999em;
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.17), 0 0 1px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    display: block;
    transition: 0.2s ease-out;
    transition-property: background-color, opacity;
  }

  &:not(:disabled):hover .button {
    background-color: #efefef;
  }

  &:hover {
    .tooltip {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &:disabled {
    cursor: default;
    .button {
      opacity: 0.3;
    }
  }

  &.bookmarked {
    i.icon {
      opacity: 1;

      &.off {
        opacity: 0;
      }
    }
  }

  i.icon {
    position: absolute;
    top: 5px;
    left: 5px;
    opacity: 0;
    transition: opacity 0.2s ease;

    &.off {
      opacity: 1;
    }
  }

  .tooltip {
    position: absolute;
    top: -21px;
    right: calc(30px + 6px + 3px);
    font-size: 13px;
    color: #444;
    text-align: left;
    white-space: nowrap;
    line-height: 1.46;
    padding: 16px 20px 17px 20px;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    z-index: 15;
    transform: translate3d(10px, 0, 0);
    opacity: 0;
    pointer-events: none;
    transition: transform 0.2s ease-out,
                opacity 0.2s ease-out;

    &.ja {
      width: 297px;
      white-space: normal;
    }

    &:after {
      position: absolute;
      right: -3px;
      top: 32px;
      content: '';
      width: 7px;
      height: 7px;
      background-color: #fff;
      box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
      transform: rotate(45deg);
    }
  }
}
</style>
